(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.common.components.youtubesubscribebutton.viewer.skins.YouTubeSubscribeButtonSkin'] = {
  "react": [
    [
      "div",
      "youtubeIframe",
      [],
      {},
      [
        "div",
        "hitWidth",
        [
          "_hitOutVertical"
        ],
        {}
      ],
      [
        "div",
        null,
        [
          "_hitOutHorizontal"
        ],
        {}
      ]
    ]
  ],
  "css": {
    "%youtubeIframe": "height:66px;display:inline-block;position:absolute;font-size:0;line-height:0;width:100%;z-index:0;",
    "%_hitOutVertical": "right:0;position:absolute;height:100%;z-index:10;",
    "%_hitOutHorizontal": "bottom:0;position:absolute;width:100%;z-index:10;",
    "%[data-state~=\"hoverMode\"]": "z-index:1;",
    "%[data-state~=\"hoverMode\"] %youtubeIframe": "height:120px;",
    "%[data-state~=\"default\"] %_hitOutVertical": "left:130px;",
    "%[data-state~=\"default\"] %_hitOutHorizontal": "top:33px;",
    "%[data-state~=\"full\"] %_hitOutVertical": "left:190px;height:53px;",
    "%[data-state~=\"full\"] %_hitOutHorizontal": "top:55px;",
    "%[data-state~=\"defaultIE\"] %_hitOutVertical": "left:141px;",
    "%[data-state~=\"defaultIE\"] %_hitOutHorizontal": "top:38px;",
    "%[data-state~=\"fullIE\"] %_hitOutVertical": "left:202px;height:65px;",
    "%[data-state~=\"fullIE\"] %_hitOutHorizontal": "top:67px;"
  }
}

        return skins;
    }));